import { Provider } from '@angular/core';

import { isViewTransitionsEnabled } from '@frontend/vanilla/core';

import { provideBrowserBackDetection } from './browser-back-detection/browser-back-detection.service';
import { provideNativeTransitionDetection } from './native-transition-detection/native-transition-detection.service';
import { provideProductSwitchDetection } from './view-transition-product-switch-detection.service';

export const provideViewTransitions = (): Provider[] => {
    if (!isViewTransitionsEnabled()) {
        return [];
    }

    return [provideProductSwitchDetection(), provideBrowserBackDetection(), provideNativeTransitionDetection()];
};
